@if (data.mobileType === 'android') {
  <mat-toolbar color="primary" class="android-prompt">
    <button mat-button (click)="installPwa()">Add to Home screen</button>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
}

@if (data.mobileType === 'ios') {
  <div class="ios-prompt">
    <button class="close-ios-inv" mat-button color="primary" (click)="close()"><mat-icon>close</mat-icon></button>
    <div>To install this web app on your device tap the Menu button and then 'Add to Home screen' button</div>
    <div>
      <img src="./assets/icons/ios-menu-btn.png" class="pwa-icon" /> <mat-icon>navigate_next</mat-icon>
      <img src="./assets/icons/ios-add-btn.png" class="pwa-icon" />
    </div>
  </div>
}
